module.exports = __webpack_public_path__ + "img/heyreach.1ee0dadd.png";